import { CoachingPlanApi } from "../openapi";
import openApiConfig from "./http_service";

const coachingPlanApi=new CoachingPlanApi(openApiConfig)

export default coachingPlanApi